<template>
    <v-dialog v-model="visible" width="500">
        <template #activator="{}">
            <v-btn color="primary" @click="open">
                {{ $t('einstellungen.dialog.button') }}
            </v-btn>
        </template>
        <Form v-slot="{ meta }">
            <form @submit.prevent="submit">
                <v-card>
                    <FocusLock>
                        <v-card-title class="headline font-weight-bold mb-2">
                            {{ $t('lieferant.details.title') }}
                        </v-card-title>
                        <v-card-text class="pb-0">
                            <v-row>
                                <v-col cols="12">
                                    <Field
                                        v-slot="{ errors, field }"
                                        v-model="formDataCopy.mwstNummer"
                                        :label="$t('lieferant.details.mwstNummer')"
                                        name="mwstNummer"
                                        :rules="getValidation('lieferantStammdatenApiDto.mwstNummer') + '|starts_with:CHE'"
                                    >
                                        <v-text-field
                                            v-bind="field"
                                            v-model="formDataCopy.mwstNummer"
                                            autofocus
                                            :label="$t('lieferant.details.mwstNummer') + ' *'"
                                            placeholder="CHE-..."
                                            variant="outlined"
                                            density="comfortable"
                                            :error-messages="errors"
                                        />
                                    </Field>
                                </v-col>
                                <v-col cols="12">
                                    <Field
                                        v-slot="{ errors, field }"
                                        v-model="formDataCopy.firma"
                                        :label="$t('lieferant.details.firmenname')"
                                        name="firmenname"
                                        :rules="getValidation('lieferantStammdatenApiDto.firma')"
                                    >
                                        <v-text-field
                                            v-bind="field"
                                            v-model="formDataCopy.firma"
                                            :label="$t('lieferant.details.firmenname') + ' *'"
                                            variant="outlined"
                                            density="comfortable"
                                            :error-messages="errors"
                                        />
                                    </Field>
                                </v-col>
                            </v-row>

                            <v-row>
                                <v-col cols="12">
                                    <Field
                                        v-slot="{ errors, field }"
                                        v-model="formDataCopy.adresszeile1"
                                        :label="$t('lieferant.details.adresszeile1')"
                                        name="adresszeile1"
                                        :rules="getValidation('lieferantStammdatenApiDto.adresszeile1')"
                                    >
                                        <v-text-field
                                            v-bind="field"
                                            v-model="formDataCopy.adresszeile1"
                                            :label="$t('lieferant.details.adresszeile1') + ' *'"
                                            variant="outlined"
                                            density="comfortable"
                                            :error-messages="errors"
                                        />
                                    </Field>
                                </v-col>
                                <v-col cols="12">
                                    <Field
                                        v-slot="{ errors, field }"
                                        v-model="formDataCopy.adresszeile2"
                                        :label="$t('lieferant.details.adresszeile2')"
                                        :rules="getValidation('lieferantStammdatenApiDto.adresszeile2')"
                                        name="adresszeile2"
                                    >
                                        <v-text-field
                                            v-bind="field"
                                            v-model="formDataCopy.adresszeile2"
                                            :label="$t('lieferant.details.adresszeile2')"
                                            variant="outlined"
                                            density="comfortable"
                                            :error-messages="errors"
                                        />
                                    </Field>
                                </v-col>
                            </v-row>

                            <v-row>
                                <v-col cols="12">
                                    <Field
                                        v-slot="{ errors, field }"
                                        v-model="formDataCopy.adresszeile3"
                                        :label="$t('lieferant.details.adresszeile3')"
                                        :rules="getValidation('lieferantStammdatenApiDto.adresszeile3')"
                                        name="adresszeile3"
                                    >
                                        <v-text-field
                                            v-bind="field"
                                            v-model="formDataCopy.adresszeile3"
                                            :label="$t('lieferant.details.adresszeile3')"
                                            variant="outlined"
                                            density="comfortable"
                                            :error-messages="errors"
                                        />
                                    </Field>
                                </v-col>
                                <v-col cols="12">
                                    <Field
                                        v-slot="{ errors, field }"
                                        v-model="formDataCopy.plz"
                                        :label="$t('lieferant.details.plz')"
                                        :rules="getValidation('lieferantStammdatenApiDto.plz')"
                                        name="plz"
                                    >
                                        <v-text-field
                                            v-bind="field"
                                            v-model="formDataCopy.plz"
                                            :label="$t('lieferant.details.plz') + ' *'"
                                            variant="outlined"
                                            density="comfortable"
                                            inputmode="numeric"
                                            type="text"
                                            :error-messages="errors"
                                            @input="formDataCopy.plz = ($event.target as HTMLInputElement).value.replace(/\D/g, '')"
                                        />
                                    </Field>
                                </v-col>
                            </v-row>

                            <v-row>
                                <v-col cols="12">
                                    <Field
                                        v-slot="{ errors, field }"
                                        v-model="formDataCopy.ort"
                                        :label="$t('lieferant.details.ort')"
                                        :rules="getValidation('lieferantStammdatenApiDto.ort')"
                                        name="ort"
                                    >
                                        <v-text-field
                                            v-bind="field"
                                            v-model="formDataCopy.ort"
                                            :label="$t('lieferant.details.ort') + ' *'"
                                            variant="outlined"
                                            density="comfortable"
                                            :error-messages="errors"
                                        />
                                    </Field>
                                </v-col>
                                <v-col cols="12">
                                    <Field
                                        v-slot="{ errors, field }"
                                        v-model="formDataCopy.land"
                                        :label="$t('lieferant.details.land')"
                                        name="land"
                                        :rules="getValidation('lieferantStammdatenApiDto.land')"
                                    >
                                        <v-select
                                            v-bind="field"
                                            v-model="formDataCopy.land"
                                            :items="countryOptions"
                                            item-title="title"
                                            item-value="value"
                                            :label="$t('lieferant.details.land') + ' *'"
                                            variant="outlined"
                                            density="comfortable"
                                            :error-messages="errors"
                                        />
                                    </Field>
                                </v-col>
                            </v-row>
                        </v-card-text>

                        <v-card-actions class="ml-4">
                            <v-btn :disabled="!meta.valid" color="primary" type="submit" variant="flat" class="modalbutton mb-3">
                                {{ $t('components.dialog.save') }}
                            </v-btn>
                            <v-btn class="modalbutton mb-3" variant="flat" @click="visible = false">
                                {{ $t('components.dialog.cancel') }}
                            </v-btn>
                        </v-card-actions>
                    </FocusLock>
                </v-card>
            </form>
        </Form>
    </v-dialog>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-facing-decorator';
import { Form, Field } from 'vee-validate';
import { namespace } from 'vuex-facing-decorator';

import { NAME as NAME_HEADERNOTIFICATION } from '@/store/modules/headerNotification';
import { NAME as NAME_LIEFERANT } from '@/areas/lieferant/store';
import { NAME as NAME_SECURITY } from '@/store/modules/security';

const headerModul = namespace(NAME_HEADERNOTIFICATION);
const lieferantModul = namespace(NAME_LIEFERANT);
const securityModul = namespace(NAME_SECURITY);
const validationModul = namespace(NAME_VALIDATION);

import { NEW_ALERT } from '@/store/modules/headerNotification/actions';
import { EDIT_LIEFERANT_DETAILS } from '@/areas/lieferant/store/actions';
import { BENUTZERINFO } from '@/store/modules/security/getters';
import { BenutzerInfoApiDto, LieferantStammdatenApiDto } from '@/api-schema';
import { GET_VALIDATION_KEY } from '@/store/modules/validation/getters';
import { NAME as NAME_VALIDATION } from '@/store/modules/validation';

interface LieferantSettingsForm {
    mwstNummer: string;
    firma: string;
    adresszeile1: string;
    adresszeile2: string;
    adresszeile3: string;
    plz: string;
    ort: string;
    land: string;
    rowVersion: string;
}

@Component({
    components: {
        Form,
        Field
    }
})
export default class EditLieferantDetails extends Vue {
    @Prop({ required: true, type: Object })
    lieferantData!: LieferantSettingsForm;

    @headerModul.Action(NEW_ALERT) alertMessage!: Function;
    @securityModul.Getter(BENUTZERINFO) benutzerInfo!: BenutzerInfoApiDto;
    @lieferantModul.Action(EDIT_LIEFERANT_DETAILS) editLieferantDetails!: Function;
    @validationModul.Getter(GET_VALIDATION_KEY) getValidation!: (key: string) => string;

    visible = false;

    formDataCopy: LieferantSettingsForm = {
        mwstNummer: 'CHE-...',
        firma: '',
        adresszeile1: '',
        adresszeile2: '',
        adresszeile3: '',
        plz: '',
        ort: '',
        land: 'CH',
        rowVersion: ''
    };

    get countryOptions() {
        return [
            { title: 'Schweiz', value: 'CH' },
            { title: 'Liechtenstein', value: 'FL' }
        ];
    }

    open() {
        this.$emit('open');
        // Copy data from parent
        this.formDataCopy = { ...this.lieferantData };
        this.visible = true;
    }
    submit() {
        this.onSave();
    }

    private onSave() {
        const apiPayload: LieferantStammdatenApiDto = {
            ...this.formDataCopy,
            plz: parseInt(this.formDataCopy.plz) || undefined
        };

        this.editLieferantDetails({
            lieferant: apiPayload,
            lieferantennummer: this.benutzerInfo.tvsLieferantenNummer.toString()
        }).then(() => {
            this.visible = false;
            this.$emit('success');
        });
    }
}
</script>
